var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckboxCheckedInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3,
    stroke: "#DFE1E4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6.58391L15.4161 5L9.29847 11.1176L5.58391 7.40306L4 8.98697L9.27971 14.2667L9.29847 14.2479L9.31723 14.2667L17 6.58391Z",
    fill: "#DFE1E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxCheckedInactive);
export default __webpack_public_path__ + "static/media/ic-checkbox-checked-inactive.5532ce8117f7ce37b738f40388cb3dc1.svg";
export { ForwardRef as ReactComponent };